import { create } from 'zustand';
import { AuthStore } from './authStore';
import { persist } from 'zustand/middleware';
import { useChatStore } from '../chat/use-chat-store';
import { useModelStore } from '../chat/use-model-store';
import { useCommonStore } from '../common/useCommonStore';
import posthog from 'analytics/posthogClient';
import { socketManager } from 'utils/socket-manager';

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isMfaEnabled: false,
      accessToken: null,
      refreshToken: null,
      selectedOrgId: null,
      isOIDCLogin: false,
      login: (accessToken, refreshToken) =>
        set({
          isAuthenticated: true,
          isMfaEnabled: true,
          accessToken,
          refreshToken,
        }),
      setAuthenticated: () =>
        set({
          isAuthenticated: true,
          isMfaEnabled: true,
        }),
      setAccessToken: (accessToken) =>
        set({
          accessToken,
        }),
      setRefreshToken: (refreshToken) =>
        set({
          refreshToken,
        }),
      setSelectedOrgId: (selectedOrgId) =>
        set({
          selectedOrgId,
        }),
      setIsOIDCLogin: (isOIDCLogin) =>
        set({
          isOIDCLogin,
        }),
      logout: () => {
        // Clear auth state
        try {
          posthog.reset();
        } catch (error) {
          console.error('Error resetting PostHog: ', error);
        }
        socketManager.cleanup();
        useChatStore.getState().reset();
        useModelStore.getState().reset();
        useCommonStore.getState().reset();

        set({
          isAuthenticated: false,
          isMfaEnabled: false,
          accessToken: null,
          refreshToken: null,
          selectedOrgId: null,
          isOIDCLogin: false,
        });

        // Clear subscription state (import done dynamically to avoid circular deps)
        import('../subscription').then(({ useSubscriptionStore }) => {
          useSubscriptionStore.getState().clearSubscription();
        });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
